import React from 'react'
import ArrayStore from "devextreme/data/array_store";
import List from "devextreme-react/list";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Text from "../../../../palette/Text";

function ListCities(props) {

    const {data, onClickCity, selectedItemKeys, ID} = props

    const dataSource = new ArrayStore({
        key: 'ID',
        data: data
    });

    function ItemTemplate(data) {
        return (
            <Layout column row center>
                <RoomOutlinedIcon style={{color: ID !== data.ID ? '#01A0EC' : 'green', width: 25, height: 25}}/>
                <LayoutChild left={7}>
                    <Text hover={false} size={14} weight={'700'} text={data.city}/>
                    <Text hover={false} size={10} weight={'500'} text={data.city}/>
                </LayoutChild>
            </Layout>
        )
    }

    return (

        <div className="list-container-prz">
            <LayoutChild width="100%" center padding={2}>
                <Text hover={false} text={'Ciudades'} size={15} color="#1A5487" weight={'900'}/>
            </LayoutChild>
            <LayoutChild width="100%" center padding={5}>
                <List
                    selectionMode="none"
                    dataSource={dataSource}
                    itemRender={ItemTemplate}
                    height="100%"
                    onItemClick={onClickCity}
                    selectedItemKeys={selectedItemKeys}
                    showSelectionControls={true}
                    searchExpr={["city"]}
                    searchEnabled={true}
                    searchMode={'contains'}
                    noDataText={'Esperando datos...'}
                />
            </LayoutChild>
        </div>
    )
}

export default ListCities